import { commonFilter } from './filter';

export default {
  pageName: 'Topic Tracking - Tree Diagram',
  pageId: '20119',
  pagePath: '/opinion/Summary/TopicTracking',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    STO_sentiment: {
      buttonId: '201190',
    },
    STT_tier1Topic: {
      buttonId: '201191',
    },
    STT_tier2Topic: {
      buttonId: '201192',
    },
    STT_definition: {
      buttonId: '201193',
    },
    ...commonFilter,
  },
};
